/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { replacePXinStringWithEM } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// PAGE : ACCOUNT : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
    account: {
        // animate in copy and details on load
        '& .name-page-copy': {
        	opacity: '0',
        	animationName: 'fadeInUp',
            animationDuration: '.2s',
            animationFillMode: 'forwards',
            animationDelay: '.1s',
        },
        '& .name-page-details': {
        	opacity: '0',
        	animationName: 'fadeInUp',
            animationDuration: '.2s',
            animationFillMode: 'forwards',
            animationDelay: '.175s',
        },

        // when tables have buttons inside them
        '& .editcolumn': {
            textAlign: 'right',
            whiteSpace: 'nowrap',
            '& .link': {
                margin: replacePXinStringWithEM(`0 7px`)
            }
        }
    }
});